"use client";

import React from "react";
import { Activity, MapPin, Thermometer, Waves, Wind } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const TICKER_ITEMS = ["BREAKING: Elbo Room announces new summer concert series lineup", "SURF REPORT: 3-4ft swells, offshore winds 10kts, water temp 80°F", "CITY NEWS: Fort Lauderdale Air Show dates officially confirmed for May", "TRAFFIC: A1A southbound experiencing heavy delays near Las Olas Blvd", "WEATHER ALERT: Afternoon thunderstorms expected, seek shelter if on the beach"];
const WEATHER_DATA = [{
  label: "Temp",
  value: "82°F",
  icon: Thermometer
}, {
  label: "Wind",
  value: "E 12mph",
  icon: Wind
}, {
  label: "Tide",
  value: "High 2:30 PM",
  icon: Waves
}];
export default function FortLauderdalePulse() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: widgetRef,
    isVisible: widgetVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="fort-lauderdale-pulse" className="dark bg-background text-foreground relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/cinematic_beach_waves.png')] bg-cover bg-center opacity-50 mix-blend-luminosity" />
        {}
        <div className="absolute inset-0 bg-background/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
      </div>

      {}
      <div ref={headlineRef} className={`relative z-10 flex w-full max-w-7xl flex-col items-center justify-center px-4 text-center transition-all duration-1000 ease-out ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <h1 className="font-serif text-6xl leading-[0.85] tracking-tight text-foreground drop-shadow-[0_0_40px_rgba(255,255,255,0.15)] md:text-8xl lg:text-[11rem]">
          THE HEARTBEAT
          <br />
          <span className="text-transparent [-webkit-text-stroke:2px_hsl(var(--foreground))]">
            OF THE BEACH
          </span>
        </h1>
      </div>

      {}
      <div ref={widgetRef} className={`absolute right-4 top-24 z-20 hidden transition-all delay-300 duration-1000 ease-out md:right-8 md:top-1/2 md:-translate-y-1/2 lg:block lg:right-12 ${widgetVisible ? "translate-x-0 opacity-100" : "translate-x-12 opacity-0"}`}>
        <div className="flex min-w-[260px] flex-col gap-6 rounded-2xl border border-border/30 bg-background/20 p-6 shadow-2xl backdrop-blur-xl">
          <div className="flex items-center gap-3 border-b border-border/30 pb-4 text-chart-2">
            <MapPin className="size-5" />
            <span className="font-serif text-2xl tracking-wider">FT. LAUDERDALE</span>
          </div>
          
          <div className="flex flex-col gap-5">
            {WEATHER_DATA.map((item, i) => <div key={i} data-index={i} className="flex items-center justify-between group">
                <div className="flex items-center gap-3">
                  <div className="flex size-8 items-center justify-center rounded-full bg-background/40 text-chart-2 transition-colors group-hover:bg-chart-2 group-hover:text-background">
                    <item.icon className="size-4" />
                  </div>
                  <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                    {item.label}
                  </span>
                </div>
                <span className="font-mono text-lg font-bold text-foreground">
                  {item.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 z-30 flex h-14 w-full items-center overflow-hidden border-t border-border/50 bg-background/80 backdrop-blur-md">
        {}
        <div className="absolute bottom-0 left-0 top-0 z-40 w-16 bg-gradient-to-r from-background to-transparent md:w-32" />
        <div className="absolute bottom-0 right-0 top-0 z-40 w-16 bg-gradient-to-l from-background to-transparent md:w-32" />

        <div className="flex animate-ticker whitespace-nowrap">
          {}
          {[...TICKER_ITEMS, ...TICKER_ITEMS].map((item, i) => <div key={i} data-index={i} className="mx-8 flex items-center gap-4">
              <Activity className="size-4 text-chart-2" />
              <span className="font-mono text-sm uppercase tracking-wider text-foreground/90">
                {item}
              </span>
            </div>)}
        </div>
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes ticker {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-ticker {
            animation: ticker 40s linear infinite;
            width: max-content;
          }
          .animate-ticker:hover {
            animation-play-state: paused;
          }
        `
    }} />
    </section>;
}